import React, { useState, useEffect } from 'react';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import { OpenSwal } from '../../Utils';
// import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import AssignmentNewRequestList from '../../Components/Interpreter/AssignmentNewRequestList';
// import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { EventUpcoming, EventBusy } from '../../SvgIcons/SvgIcons';
import useMediaQuery from '@mui/material/useMediaQuery';
import { url_fetch_dashboard } from '../../RoutesMap';
import { TextUnderlineHeading } from '../../Styles';
import { apiWithAuth } from '../../Services/Axios/axios';

const cardTheme = ({  //white theme
  colors: {
    text: '#ffffff',
    main: '#f2f2f2',
    dark: '#f2f2f2',
    contrastText: '#03070f',
  },
  cardborderRadius: '15px'
});




export default function InterpreterDashboard({ PusherDashboardTrigger }) {
  let navigate = useNavigate();
  const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
  // const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
  const width600above = useMediaQuery('(width>=600px)');


  const [cardCountsCanUpcom, cardCountsCanUpcomSet] = useState({
    cancel_count: 0,
    upcoming_count: 0,
    active_count: 0,
    pending_count: 0,
    unbilled_count: 0,
    submission_count:0,
    verification_count:0,
    billed_count: 0,
    cancel_datetime: 'N/A',
    upcoming_datetime: 'N/A',
    active_datetime: 'N/A',
    pending_datetime: 'N/A',
    unbilled_datetime: 'N/A',
    billed_datetime: 'N/A',
    submission_datetime: 'N/A',
    verification_datetime: 'N/A'
  });

  useEffect(() => {
    apiWithAuth.post(url_fetch_dashboard, {}, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
      if (response.data.status) {
        cardCountsCanUpcomSet({
          cancel_count: response.data.data.cancel_count,
          upcoming_count: response.data.data.upcoming_count,
          active_count: response.data.data.active_count,
          pending_count: response.data.data.pending_count,
          unbilled_count: response.data.data.unbilled_count,
          billed_count: response.data.data.billed_count,
          submission_count: response.data.data.submission_count,
          verification_count: response.data.data.verification_count,
          cancel_datetime: response.data.data.cancel_datetime,
          upcoming_datetime: response.data.data.upcoming_datetime,
          active_datetime: response.data.data.active_datetime,
          pending_datetime: response.data.data.pending_datetime,
          unbilled_datetime: response.data.data.unbilled_datetime,
          submission_datetime: response.data.data.submission_datetime,
          verification_datetime: response.data.data.verification_datetime
        });
      } else if (response.data.status === false && response.data.message === "Token Expired") {
        OpenSwal('Token_error', navigate);
      } else {
        OpenSwal('Axios_error', response.data.message);
      }
    }).catch(response => {
      OpenSwal('Axios_error', response.message);
    });
  }, [PusherDashboardTrigger]);

  const openListnavigate = (path) => {
    navigate('/Interpreter/' + path);
  }

  return (
    <Box  >
      <Box sx={{ mb: 1, ml: 0.5 }}>
        <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={TextUnderlineHeading} >Dashboard</Typography>
      </Box>
      <Grid container spacing={{ xs: 0.8, sm: 1, md: 2, lg: 3 }}>
{/* 
        {[{ menu_name: 'Upcoming_list', menu_text: 'Upcoming', card_color: '#E2357C', menu_icon: <EventUpcoming color={cardTheme.colors.text} size={width600above ? "3em" : "2em"} />, card_count: cardCountsCanUpcom.upcoming_count, asn_last_date: cardCountsCanUpcom.upcoming_datetime },
        { menu_name: 'Cancelled_list', menu_text: 'Cancelled', card_color: '#FF4C3B', menu_icon: <EventBusy color={cardTheme.colors.text} size={width600above ? "3em" : "2em"} />, card_count: cardCountsCanUpcom.cancel_count, asn_last_date: cardCountsCanUpcom.cancel_datetime }].map((data, key) => {
           */}
          {[
          { menu_name: 'Upcoming_list', menu_text: 'Upcoming', card_color: '#E2357C',  card_count: cardCountsCanUpcom.upcoming_count, asn_last_date: cardCountsCanUpcom.upcoming_datetime },
          { menu_name: 'Active_list', menu_text: 'Active', card_color: '#10548f',  card_count: cardCountsCanUpcom.active_count, asn_last_date: cardCountsCanUpcom.active_datetime },
          { menu_name: 'Action_list', menu_text: 'Action Pending', card_color: '#820295',  card_count: cardCountsCanUpcom.pending_count, asn_last_date: cardCountsCanUpcom.pending_datetime },
          { menu_name: 'Raise_invoice', menu_text: 'Raise Invoice', card_color: '#009F96', card_count: cardCountsCanUpcom.unbilled_count, asn_last_date: cardCountsCanUpcom.unbilled_datetime },
          { menu_name: 'Billed_list', menu_text: 'Billed', card_color: '#d86339', card_count: cardCountsCanUpcom.billed_count, asn_last_date: cardCountsCanUpcom.billed_datetime }].map((data, key) => {

          return (<Grid xs={6} sm={4} md={3} key={key} >
            <Card sx={{ backgroundColor: data.card_color, borderRadius: cardTheme.cardborderRadius, cursor: 'pointer', position: 'relative' }}>
              <CardContent sx={{ padding: { xs: '8px', sm: '14px', md: '16px' } }} onClick={() => openListnavigate(data.menu_name)}>

                <Typography sx={{ typography: { xs: 'subtitle1', sm: 'h5', md: 'h4' } }} color={cardTheme.colors.text} > {data.menu_text} </Typography>
                <Box sx={{ position: 'absolute', right: 4, top: { xs: 5, sm: 10, md: 15 } }}>{data.menu_icon}
                </Box>
                <Typography sx={{ typography: { xs: 'h4', sm: 'h4', md: 'h2' }, mb: { xs: -1, md: -2 } }} color={cardTheme.colors.text} >
                  {data.card_count}
                </Typography>
                <Typography sx={{ typography: { xs: 'body1', sm: 'subtitle1', md: 'h6' } }} style={{ fontWeight: 'lighter' }} color={cardTheme.colors.text} > Assignments </Typography>
                {/* <Stack direction='row' sx={{ mt: 0.5, mb: -2 }}  >
                  <TimerOutlinedIcon sx={{ color: cardTheme.colors.text, fontSize: { xs: '15px', sm: '16px', md: '20px' }, mt: { xs: '1.5px', sm: '3px', md: '3px' }, mr: 0.2 }} />
                  <Typography style={{ fontFamily: 'lato', whiteSpace: 'nowrap', letterSpacing: '-0.2px' }} sx={{ typography: { xs: 'caption', sm: 'body1', md: 'subtitle1' } }} color={cardTheme.colors.text}>  {data.asn_last_date} </Typography>

                </Stack> */}
              </CardContent>
            </Card>
          </Grid>)
        })}

      </Grid>
      <Box sx={{ mb: 5 }}>
        <AssignmentNewRequestList assign_id='' PusherDashboardTrigger={PusherDashboardTrigger} />
      </Box>
    </Box >
  );
}